var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "configurationErrorDiv" },
    [
      _c(
        "v-container",
        [
          _c("v-flex", { staticClass: "text-xs-center" }, [
            _c("p", [
              _vm._v("Unable to retrieve BedBoard configuration.  Press the "),
              _c("b", [_vm._v("Retry")]),
              _vm._v(
                " button below to attempt to retrieve configuration again."
              )
            ]),
            _c("p", [
              _vm._v(
                "If this continues, please contact support with this messsage."
              )
            ])
          ]),
          _c(
            "v-flex",
            { staticClass: "text-xs-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ntstAppButton",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.retry()
                    }
                  }
                },
                [_vm._v("\n        Retry\n      ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ntstAppButton",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.logout()
                    }
                  }
                },
                [_vm._v("\n        Logout\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }